import { FETCH_ROLE_SUCCESS } from "./RoleActionTypes";

const initialState = { roles: [] };

export const RoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROLE_SUCCESS:
      return { ...state, roles: action.data };

    default:
      return state;
  }
};
